export default __webpack_public_path__ + "static/113-9a150606385c4dc5ede54099334022e3.jpg";